<template>
  <InsurerPage :insurerSlug="$route.params.token">
    <template v-slot="{ insurer }">
      <v-app>
        <v-main>
          <v-container>
            <div class="text-center mb-3" style="width: 100%">
              <InsurerLogo :insurer="insurer" />
            </div>
            <v-row dense>
              <v-col>
                <v-card style="max-width: 450px" class="mx-auto pa-5" outlined>
                  <v-card-title>
                    Início da participação de sinistro
                  </v-card-title>
                  <v-card-text>
                    Este processo é simples e guiado. Em poucos minutos poderá
                    submeter as informações necessárias para que possamos
                    proceder à abertura do seu sinistro.

                    <br /><br />

                    <b>Durante este processo, iremos:</b> <br /><br />

                    <ul>
                      <li>Recolher a sua <b>descrição do ocorrido</b></li>
                      <li>
                        Solicitar <b>fotografias</b> dos equipamentos afetados
                      </li>
                      <li>Solicitar <b>orçamentos</b> ou <b>facturas</b></li>
                    </ul>

                    <br />

                    <span class="font-weight-bold">⏱️ Tempo estimado: </span>
                    5 a 10 minutos

                    <br />
                  </v-card-text>

                  <v-card-actions class="mt-2">
                    <v-btn
                      block
                      :color="insurer.color"
                      dark
                      @click="handleClickStart()"
                    >
                      Iniciar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-main>
      </v-app>
    </template>
  </InsurerPage>
</template>

<script>
import InsurerPage from "@/components/insurers/InsurerPage";
import InsurerLogo from "@/components/insurers/InsurerLogo.vue";

export default {
  mixins: [],

  components: {
    InsurerPage,
    InsurerLogo,
  },

  props: {},

  data() {
    return {};
  },

  methods: {
    handleClickStart() {
      localStorage.removeItem("equipaments");
      localStorage.removeItem("participation");
      localStorage.removeItem("step");
      localStorage.removeItem("insured");
      localStorage.removeItem("date");
      localStorage.removeItem("participants");
      localStorage.removeItem("dna_documents");
      localStorage.removeItem("risk_location_damages");
      localStorage.removeItem("claim_flow");

      this.$router.push({ name: "customers-inbound-auth" });
    },
  },

  computed: {},
};
</script>
